import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "wrap", "justify", "alignItems"];
import { Grid } from '@material-ui/core';
import { Children, forwardRef } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * @deprecated in favor of `Inline` component.
 */
export var InlineGrid = /*#__PURE__*/forwardRef((_ref, ref) => {
  var {
      children,
      wrap = 'wrap',
      justify = 'flex-start',
      alignItems = 'flex-start'
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  var items = Children.toArray(children);
  return /*#__PURE__*/_jsx(Grid, _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    wrap: wrap,
    container: true,
    justify: justify,
    alignItems: alignItems,
    children: items.map((item, idx) => /*#__PURE__*/_jsx(Grid, {
      item: true,
      zeroMinWidth: true,
      children: item
    }, idx))
  }));
});
if (process.env.NODE_ENV !== "production") InlineGrid.displayName = "InlineGrid";